import {Component, Injector} from '@angular/core';
import {AlertController, MenuController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {UserSessionDto} from '../../Models/User/user-session.interface';
import {AuthApiService} from '../../Services/Api/Auth/auth-api.service';
import {ToastManagerService} from '../../Services/Platform/Ionic/toast-manager.service';
import {AnimationsManagerService} from '../../Services/Platform/Ionic/animations-manager.service';
import {AppConfigManagerService} from '../../Services/Shared/app-config-manager.service';
import {PermissionsManagerService} from '../../Services/Shared/permissions-manager.service';
import {TagManagerService} from '../../Services/Platform/Ionic/tag-manager.service';
import {HapticsImpactManagerService} from '../../Services/Platform/Capacitor/haptics-impact-manager.service';

@Component({
  template: '',
  standalone: false
})
export abstract class ControllerComponent {

  user!: UserSessionDto | null;

  public permissionsManager: PermissionsManagerService;
  public tagManager: TagManagerService;

  protected auth: AuthApiService;
  protected translate: TranslateService;
  protected menuCtrl: MenuController;
  protected alertCtrl: AlertController;
  protected toastCtrl: ToastManagerService;
  protected animationCtrl: AnimationsManagerService;
  protected appConfigManager: AppConfigManagerService;
  protected hapticsImpactManager: HapticsImpactManagerService;

  protected constructor(
    protected injector: Injector
  ) {
    this.permissionsManager = this.injector.get<PermissionsManagerService>(PermissionsManagerService);
    this.tagManager = this.injector.get<TagManagerService>(TagManagerService);
    this.auth = this.injector.get<AuthApiService>(AuthApiService);
    this.translate = this.injector.get<TranslateService>(TranslateService);
    this.menuCtrl = this.injector.get<MenuController>(MenuController);
    this.alertCtrl = this.injector.get<AlertController>(AlertController);
    this.toastCtrl = this.injector.get<ToastManagerService>(ToastManagerService);
    this.animationCtrl = this.injector.get<AnimationsManagerService>(AnimationsManagerService);
    this.appConfigManager = this.injector.get<AppConfigManagerService>(AppConfigManagerService);
    this.hapticsImpactManager = this.injector.get<HapticsImpactManagerService>(HapticsImpactManagerService);

    this.user = this.auth.getUserSession();
  }

}
